// Placeholder sayfalar — sidebar nav'da var ama henüz tam içerikleri pending.
// Her sayfa müşteriye ne olacağını anlatan kısa bir özet + "Hangi backend
// servis bekliyor?" notu sunar.

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Icon, type IconKey } from "../../icons";

type PlaceholderStatus = "live-data-pending" | "backend-pending" | "hardware-pending";

interface PlaceholderProps {
  icon: IconKey;
  titleKey: string;
  descriptionKey: string;
  status: PlaceholderStatus;
  featuresKey: string;
  blockersKey: string;
}

function Placeholder({ icon, titleKey, descriptionKey, status, featuresKey, blockersKey }: PlaceholderProps) {
  const { t } = useTranslation("dashboard");
  const features = t(featuresKey, { returnObjects: true }) as string[];
  const blockers = t(blockersKey, { returnObjects: true }) as string[];
  return (
    <div className="placeholder">
      <div className="placeholder-head">
        <div className="placeholder-icon">
          <Icon name={icon} size={36} />
        </div>
        <div>
          <h1>{t(titleKey)}</h1>
          <p className="muted">{t(descriptionKey)}</p>
          <span className={`status-pill status-${status}`}>{t(`placeholder.status.${status}`)}</span>
        </div>
      </div>
      <div className="placeholder-grid">
        <div>
          <h3>{t("placeholder.willHappen")}</h3>
          <ul className="checklist">
            {features.map((f) => (
              <li key={f}>
                <Icon name="check" size={16} />
                <span>{f}</span>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3>{t("placeholder.blockers")}</h3>
          <ul className="blocker-list">
            {blockers.map((b) => (
              <li key={b}>
                <Icon name="alert" size={14} />
                <span>{b}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="placeholder-foot">
        <Link to="/overview" className="ghost">
          <span aria-hidden>&larr;</span> {t("placeholder.backToOverview")}
        </Link>
      </div>
    </div>
  );
}

export function EventsPage() {
  return (
    <Placeholder
      icon="bolt"
      titleKey="events.title"
      descriptionKey="events.description"
      status="live-data-pending"
      featuresKey="events.features"
      blockersKey="events.blockers"
    />
  );
}

export { DriverPage } from "./DriverPage";
export { DeliveryPage } from "./DeliveryPage";

export { FuelPage } from "./FuelPage";

export function OcrPage() {
  return (
    <Placeholder
      icon="scan"
      titleKey="ocr.title"
      descriptionKey="ocr.description"
      status="backend-pending"
      featuresKey="ocr.features"
      blockersKey="ocr.blockers"
    />
  );
}

export { BorderPage } from "./BorderPage";

export { ReportsPage } from "./ReportsPage";
